import { createActions } from "reduxsauce";

export default createActions(
  {
    entityRepositoryHasChanged: ["repository"]
  },
  {
    prefix: "entity-repository/"
  }
);



// WEBPACK FOOTER //
// ./src/modules/entity-repository/entity-repository-actions.js